import builder from '../builder';
import ButtonLoop from '../../streamline-icons/bold/button-loop.svg';

export default builder('IconButtonLoopBold', ButtonLoop);
